<template>
    <fieldset class="vrm-mfa-options-form vrm-fieldset vrm-checklist" :class="{ readonly }">
        <div class="vrm-mfa-options-form__option vrm-checklist__box" @click="method = 'password'">
            <vrm-toggle-radio
                v-model="method"
                value="password"
                :disabled="readonly"
                class="vrm-checklist__icon"
            >
                {{ $t('mfa.options_password_only_name', { i18nFallback: 'Password only' }) }}
            </vrm-toggle-radio>
            <div>
                {{
                    $t('mfa.options_password_only_description', {
                        i18nFallback:
                            'Your account only requires a password to log-in. This is the lowest protection grade for your account.',
                    })
                }}
            </div>
        </div>
        <div class="vrm-mfa-options-form__option vrm-checklist__box" @click="method = 'mobile'">
            <vrm-toggle-radio
                v-model="method"
                value="mobile"
                :disabled="readonly"
                class="vrm-checklist__icon"
            >
                {{ $t('mfa.options_mobile_name', { i18nFallback: 'Authenticator app' }) }}
                <vrm-text-badge
                    :i18n="{
                        key: 'general.recommended_badge',
                        fallback: 'Recommended',
                    }"
                />
            </vrm-toggle-radio>
            <div>
                {{
                    $t('mfa.options_mobile_description', {
                        i18nFallback:
                            'After entering your password you enter a one-time code provided by an app installed on your mobile phone.',
                    })
                }}
            </div>
            <div v-if="method === 'mobile' && !readonly">
                <router-link class="sg-btn sg-blue" :to="{ name: 'base.profile.twofactor.mobile' }">
                    {{ $t('mfa.options_mobile_add_device', { i18nFallback: 'Add device' }) }}
                </router-link>
                <router-link
                    class="sg-btn sg-red"
                    :to="{ name: 'base.profile.twofactor.mobile', params: { mode: 'reset' } }"
                >
                    {{
                        $t('mfa.options_mobile_revoke_devices', { i18nFallback: 'Revoke devices' })
                    }}
                </router-link>
            </div>
        </div>
        <div class="vrm-mfa-options-form__option vrm-checklist__box" @click="method = 'sms'">
            <vrm-toggle-radio
                v-model="method"
                value="sms"
                :disabled="readonly"
                class="vrm-checklist__icon"
            >
                {{ $t('mfa.options_sms_name', { i18nFallback: 'SMS verification' }) }}
            </vrm-toggle-radio>
            <div>
                {{
                    $t('mfa.options_sms_description', {
                        i18nFallback:
                            'Your identity is confirmed with an SMS code sent to your phone.',
                    })
                }}
            </div>
            <div v-if="method === 'sms'">
                <b>{{ $t('mfa.options_sms_phonenumber', { i18nFallback: 'Phonenumber' }) }}:</b>
                <span>{{ phone }}</span>
                <router-link
                    v-if="!readonly"
                    class="sg-btn sg-blue vrm-mfa-options-form__change-phone"
                    to="base.profile.twofactor.sms"
                >
                    {{ $t('mfa.options_sms_change', { i18nFallback: 'Change' }) }}
                </router-link>
            </div>
        </div>
    </fieldset>
</template>
<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import VrmToggleCheckmark from '@/vue/components/shared/toggles/VrmToggleCheckmark';
import VrmToggleRadio from '@/vue/components/shared/toggles/VrmToggleRadio';
import VrmTextBadge from '@/vue/components/shared/VrmTextBadge';
import { ngInject } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component({
    components: { VrmToggleRadio, VrmToggleCheckmark, VrmTextBadge },
})
@AngularLocaleBundle('mfa')
export default class VrmRadioList extends Vue {
    @Prop({ type: Boolean, default: false })
    readonly;

    get phone() {
        return this.$store.state.MfaService.phone;
    }

    @ngInject()
    ApiService;

    async created() {
        this.$store.dispatch('MfaService/ensureMfaSettings');
    }

    get method() {
        return this.$store.state.MfaService.mode;
    }

    set method(value) {
        if (!this.readonly && value !== this.method) {
            this.$emit('change-method', value);
        }
    }
}
</script>
